import { IntentState, Intent } from '../../model/intent/types';
import {
  IntentActionTypes,
  FILL_INTENTS,
  saveIntentActionType,
  deleteIntentActionType,
} from '../../model/intent/action';
import { replaceOrInsert } from '../../helpers/immutableHelper';

const initialState: IntentState = {
  intents: [],
};

export function intentReducer(
  state = initialState,
  action: IntentActionTypes,
): IntentState {
  switch (action.type) {
    case FILL_INTENTS:
      return {
        intents: action.payload,
      };
    case saveIntentActionType.success:
      return {
        intents: replaceOrInsert<Intent>(state.intents, action.payload),
      };
    case deleteIntentActionType.success:
      return {
        intents: state.intents.filter((x) => x.id !== action.payload),
      };
    default:
      return state;
  }
}
